// sharedServices.js

import { SYSTEM_ERROR } from "../config/CONSTANTS";
import { SAVE_APPLICATION_USAGE, CREATE_PII_AUDIT_LOG } from "./CONSTANTS";
import axiosInstance from "./axiosInstance";

const BASE_URL = process.env.REACT_APP_BASE_URL_CONFIG;

export const checkPermission = async (access) => {
  if (!access) return [];

  const allPermissions = [
    "General_Limited_Group",
    "PII_Group",
    "Ops_Group",
    "OG_Group",
    "LD_Group",
    "LD_Group_Admin",
    "TA_Group",
    "WFM_Group",
  ];

  return allPermissions.filter((item) => access.includes(item));
};

export const saveApplicationUagsage = (
  UsedBy,
  UsedByEmail,
  AppName,
  ModuleName,
) => {
  return new Promise((resolve) => {
    try {
      const url =
        BASE_URL +
        SAVE_APPLICATION_USAGE() +
        `?UsedBy=${UsedBy}&UsedByEmail=${UsedByEmail}&ApplicationName=${AppName}&ModuleName=${ModuleName}`;

      axiosInstance
        .post(url, {})
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          resolve({ error: true });
        });
    } catch {
      resolve({ error: true });
    }
  });
};

// ASTT-7304: PII Access Logging.
// Fire-and-forget: logging failures should never block or surface errors on the
// PII report screens themselves, so all failure paths resolve quietly.
export const savePIIAuditLog = ({
  oracleIds,
  piiRequestBy,
  piiRequestByEmail,
  userGroup,
  sourceModule,
  moduleReference,
  piiFieldsShown,
  piiFieldsMasked,
}) => {
  return new Promise((resolve) => {
    try {
      const url = BASE_URL + CREATE_PII_AUDIT_LOG();

      const body = {
        OracleIds: oracleIds,
        PIIRequestBy: piiRequestBy,
        PIIRequestByEmail: piiRequestByEmail,
        UserGroup: userGroup,
        SourceModule: sourceModule,
        ModuleReference: moduleReference,
        PIIFieldsShown: piiFieldsShown,
        PIIFieldsMasked: piiFieldsMasked,
      };

      axiosInstance
        .post(url, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          resolve({ error: true });
        });
    } catch {
      resolve({ error: true });
    }
  });
};
